import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "./failhandler";

var loadmore = (function() {

    if ( $("#teaser-item-template").length > 0) {
        var main 		    = $('#main'),
            source   	    = $("#teaser-item-template").html(),
            template        = Handlebars.compile(source),
            responseWrap    = $('.response-wrapper'),
            loadmoreBtn     = $('.load-more a'),
            cl 			    = new CanvasLoader('loader');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#444444');
        cl.setFPS(24);

        main.on('click', '.load-more a', function(e) {
            e.preventDefault();
            var loadmoreBtn = $(this);
            loadmoreBtn.hide();
            cl.show();

            
            var pageId = loadmoreBtn.data('pageid'),
                containerId = loadmoreBtn.data('containerid');

            if (typeof pageId !== 'undefined' && typeof containerId !== 'undefined') {

                var data = {
                    lastShowedArticle: pageId,
                    containerId: containerId
                };

                var ajaxRequest = $.ajax({
                    url: SETTINGS.services.site.methods.getArticles,
                    method: "POST",
                    data: JSON.stringify(data)
                });

                ajaxRequest.done(doneHandler);
                ajaxRequest.fail(failHandler);
            } else {
                cl.hide();
                loadmoreBtn.show();
            }
        });
        
        function doneHandler(response) {

            if (response.Success) {
                var obj     = buildMultiDimensionArray(response.Data),
                    html    = template(obj);
                
                responseWrap.append(html);

                if (response.MoreAvailable) {
                    loadmoreBtn.show();
                }
            } else {
                displayGenericError(responseWrap, response);                                               
            }
            cl.hide();
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            serviceNetworkError(responseWrap);            
            cl.hide();
        }

        function buildMultiDimensionArray(response) {

            var result = [], temp = [];

            for (var i = 0; i < response.length; i++) {
                if (i > 0 && i % 3 === 0) {
                    result.push(temp);
                    temp = [];
                }
                temp.push(response[i]);
            }

            if (temp.length > 0) {
                result.push(temp);
            }

            return result;
        }
    }
})();